import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslocoService } from '@ngneat/transloco';
import { BaseForm } from 'projects/admin/src/app/classes/base-form';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { FormHelper } from 'projects/admin/src/app/shared/form-helper';
import { ToolboxCandidateModel } from 'projects/core/src/lib/models/toolbox-candidate.model';

@Component({
  selector: 'app-toolbox-candidate-credentials',
  templateUrl: './toolbox-candidate-credentials.component.html',
  styleUrls: ['./toolbox-candidate-credentials.component.scss']
})
export class ToolboxCandidateCredentialsComponent extends BaseForm implements OnInit {

  @Input() order: ToolboxCandidateModel = null;
  @Output() setEdit = new EventEmitter<string>();

  public form: UntypedFormGroup = this.fb.group({
    login_url: new UntypedFormControl(null, [Validators.required]),
    login_user: new UntypedFormControl(null),
    login_password: new UntypedFormControl(null),
    login_informations: new UntypedFormControl(null),
  });

  constructor(
    private fb: UntypedFormBuilder,
    private ui: UiService,
    private api: ApiService,
    private auth: AuthStateService,
    public transloco: TranslocoService
  ) {
    super();
  }

  ngOnInit(): void {
    this.ui.setFocus();
  }

  onSubmit(): void {
    this.ui.hideMessage();
    if (this.form.valid === true) {
      this.submitting = true;
      const payload = {
        login_url: this.form.get('login_url').value,
        login_user: this.form.get('login_user').value,
        login_password: this.form.get('login_password').value,
        login_informations: this.form.get('login_informations').value,
      };
      this.api.saveToolboxCredentials(this.order.id, payload).subscribe({
        next: (result: any) => {
          this.ui.toastSuccess(this.transloco.translate('common.messages.saved', { value: this.form.value.name }), this.transloco.translate('common.saved'));
          this.order = new ToolboxCandidateModel().deserialize(result.data);
          this.stopEdit();
        },
        error: (error: any) => {
          this.ui.showMessage('error', this.transloco.translate(error.message), this.transloco.translate('common.error'));
          FormHelper.setBackendErrors(this.form, error.fielderrors);
        }
      }).add(() => {
        this.submitting = false;
      });
    } else {
      this.ui.showMessage('error', this.transloco.translate('common.error_on_form_please_correct'), this.transloco.translate('common.error'));
      FormHelper.markFormAsDirty(this.form);
    }
  }

  onEdit(): void {
    if (this.auth.hasRight('admin.toolboxcandidate.edit')) {
      this.startEdit();
    }
  }

  startEdit(): void {
    if (this.order !== null) {
      this.form.patchValue({
        login_url: this.order.login_url,
        login_user: this.order.login_user,
        login_password: this.order.login_password,
        login_informations: this.order.login_informations,
      });
    }
    this.inEdit = true;
    this.setEdit.emit('credentials');
    this.ui.setFormFocus();
  }

  stopEdit(): void {
    this.inEdit = false;
    this.setEdit.emit(null);
    this.ui.setFocus();
  }

}
